export default async (roleStartsWith: string) => {
  const rolesStore = useRolesStore();
  const { fetchRoles } = rolesStore;
  const { roles } = storeToRefs(rolesStore);

  await fetchRoles;
  return roles.value.find(role =>
    role.name === `${roleStartsWith} Reviewer`,
  );
};
